goog.provide('yext.m4.errors.ErrorsService');

yext.m4.errors.ErrorsService = class {
  /**
   * @param {!Function} onSetDiagnostics
   * @param {!Function} onRemoveDiagnostics
   */
  constructor(onSetDiagnostics, onRemoveDiagnostics) {
    this.onSetDiagnostics = onSetDiagnostics;
    this.onRemoveDiagnostics = onRemoveDiagnostics;
    this.errors = [];
    this.warnings = [];
  }

  /**
   * Sets the state of the errors and warnings, and calls this.onSetDiagnostics.
   *
   * @param {!Array<!yext.m4.errors.DiagnosticData.Diagnostic>} errors
   * @param {!Array<!yext.m4.errors.DiagnosticData.Diagnostic>} warnings
   */
  setDiagnostics(errors, warnings) {
    this.errors = errors;
    this.warnings = warnings;
    this.onSetDiagnostics({'errors': errors, 'warnings': warnings});
  }

  /**
   * Removes the errors and warnings specified, and calls this.onRemoveDiagnostics.
   *
   * @param {!Array<!yext.m4.errors.DiagnosticData.Diagnostic>} errorsToRemove
   * @param {!Array<!yext.m4.errors.DiagnosticData.Diagnostic>} warningsToRemove
   */
  removeDiagnostics(errorsToRemove, warningsToRemove) {
    if (!errorsToRemove.length && !warningsToRemove.length) {
      return;
    }
    this.errors = this.errors.filter(e => !errorsToRemove.includes(e));
    this.warnings = this.warnings.filter(w => !errorsToRemove.includes(w));
    this.onRemoveDiagnostics({
      'removedErrors': errorsToRemove,
      'removedWarnings': warningsToRemove,
      'newState': {
        'errors': this.errors,
        'warnings': this.warnings,
      },
    });
  }

  /**
   * Returns the current diagnostics
   * @return {!Object}
   */
  getCurrentDiagnostics() {
    return {
      'errors': this.errors,
      'warnings': this.warnings,
    };
  }
};
